import React from 'react';
import ThemedCard from '../../themed/ThemedCard';
import { SeatingStats } from '../types';

interface TableSummaryBarProps {
  stats: SeatingStats;
  tableCount: number;
}

export const TableSummaryBar: React.FC<TableSummaryBarProps> = ({ stats, tableCount }) => {
  const { totalGuests, assignedGuests, unassignedGuests, totalCapacity } = stats;

  return (
    <ThemedCard className="p-4 bg-gradient-to-r from-wedding-pink/10 to-wedding-gold/10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-wedding-pink">{tableCount}</div>
          <div className="text-sm text-wedding-text-body">總桌數</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-wedding-pink">{totalGuests}</div>
          <div className="text-sm text-wedding-text-body">總出席人數</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-wedding-gold">{assignedGuests}</div>
          <div className="text-sm text-wedding-text-body">已安排座位</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-wedding-gold">{unassignedGuests}</div>
          <div className="text-sm text-wedding-text-body">未安排座位</div>
        </div>
      </div>
      {totalCapacity > 0 && (
        <div className="mt-3 text-center">
          <div className="text-sm text-wedding-text-body">
            座位使用率: <span className="font-semibold text-wedding-text-title">{Math.round((assignedGuests / totalCapacity) * 100)}%</span>
            ({assignedGuests}/{totalCapacity})
          </div>
        </div>
      )}
    </ThemedCard>
  );
};
